<div>
  <mat-dialog-content>
    <div class="description">
      {{ data.promptText }}
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button
      mat-button
      color="primary"
      data-cy="cancel-button"
      (click)="modalService.dialogRef.close(false)"
    >
      Cancel
    </button>
    <button
      mat-flat-button
      class="mdc-button--success"
      data-cy="confirm-button"
      (click)="modalService.dialogRef.close(true)"
    >
      Confirm
    </button>
  </mat-dialog-actions>
</div>
